export default {"src":"/_next/static/media/Harry.1c914e53.svg","height":350,"width":350,"blurWidth":0,"blurHeight":0};